import React from "react"
import { AuthRoles } from "components/auth"

export const VehicleOrderServicesConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/vehicle_order_services`,
      component: React.lazy(() => import("./VehicleOrderServices")),
    },
  ],
}
